import { registerDecorator } from 'class-validator';
/**
 * Abrechnungscode — the first two characters of the Leistungserbringergruppen-
 * schlüssel (LEGS), assigned to the practice at Zulassung / on concluding the
 * Vergütungsvereinbarung. Never derived by us.
 *
 * Anhang 3 §5 types the field `AN 2`, and Anhang 3 §8.14's Heilmittel branch
 * prints `20` Gruppenschlüssel with `21/22/23/26/29` beneath it, plus the
 * recipient-side catch-alls `00` Sammelschlüssel and `99` Sonderschlüssel.
 *
 * **No value whitelist here, deliberately.** That published branch is not the
 * whole assignable set: the §124 Abs. 5 groups (Krankenhaus, Kurbetrieb) bill
 * under `27`/`28`, which §8.14 does not print at all, and the Haushaltshilfe
 * codes `C0`–`C4` that Anhang 3 V10 added show the namespace is alphanumeric and
 * still growing. A whitelist would reject a legitimately-assigned code and block
 * onboarding outright, which is strictly worse than letting the Kasse reject a
 * wrong one. The shape is checked; the value is the practice's paperwork.
 */
export const BILLING_CODE_LENGTH = 2;
const BILLING_CODE_PATTERN = /^[0-9A-Z]{2}$/;
export function normalizeBillingCode(value) {
    return (value ?? '').trim().toUpperCase();
}
export function isBillingCodeValid(value) {
    return BILLING_CODE_PATTERN.test(normalizeBillingCode(value));
}
export function IsValidBillingCode(validationOptions) {
    return function (object, propertyName) {
        registerDecorator({
            name: 'isValidAbrechnungscode',
            target: object.constructor,
            propertyName,
            options: {
                message: 'Abrechnungscode ist ungültig (zwei Zeichen, Ziffern oder Großbuchstaben)',
                ...validationOptions,
            },
            validator: {
                validate(value) {
                    return typeof value === 'string' && isBillingCodeValid(value);
                },
            },
        });
    };
}
//# sourceMappingURL=abrechnungscode.js.map